// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
`;

const Card = styled.img`
  height: 28px;
  width: auto;
  border-radius: 4px;
  display: block;
`;

const WalletBadge = styled.span<{ $background?: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 28px;
  border-radius: 4px;
  background: ${({ $background }) => $background || '#ffffff'};

  img {
    width: 36px;
    height: 22px;
    display: block;
  }
`;

const PaymentBadges = () => {
  return (
    <Row aria-label="Accepted payment methods">
      <Card src="/images/payments/visa.svg" alt="Visa" />
      <Card src="/images/payments/mastercard.svg" alt="Mastercard" />
      <Card src="/images/payments/amex.svg" alt="American Express" />
      <Card src="/images/payments/paypal.svg" alt="PayPal" />
      <WalletBadge $background="#FFB3C7">
        <img src="/images/payments/klarna.svg" alt="Klarna" />
      </WalletBadge>
      <Card src="/images/payments/applepay.svg" alt="Apple Pay" />
      <Card src="/images/payments/googlepay.svg" alt="Google Pay" />
    </Row>
  );
};

export default PaymentBadges;
